import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M14.076 18.01H3.623A1.623 1.623 0 0 1 2 16.385v-8.77c0-.898.726-1.625 1.623-1.625h10.453c.897 0 1.623.727 1.623 1.625v8.757c0 .911-.726 1.638-1.623 1.638ZM15.95 10.006l5.266-2.576a.31.31 0 0 1 .448.277v8.375c0 .237-.25.383-.448.277l-5.174-2.629"
    />
  </svg>
);
export const VideoIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
